import React from 'react';
import DOMPurify from '../../../utils/purify.min.js';
import linkifyHtml from 'linkify-html';

import styles from './new_conversation_room.module.css';

export default function MessageTriggerNote({ note }) {
  return (
    <div className={styles.trigger_note} data-note-type={note.type}>
      <p
        className={styles.trigger_note_text}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(linkifyHtml(note.text, { target: '_blank', rel: 'noopener noreferrer' })),
        }}
      />
    </div>
  );
}
